// extracted by mini-css-extract-plugin
export var active = "passwordStrength-module--active--69f3a";
export var iconBackground = "passwordStrength-module--iconBackground--34d51";
export var iconWithOutline = "passwordStrength-module--iconWithOutline--4b60b";
export var passwordStrength = "passwordStrength-module--passwordStrength--cccd0";
export var requirement = "passwordStrength-module--requirement--3cbd8";
export var requirementIcon = "passwordStrength-module--requirementIcon--32428";
export var requirementText = "passwordStrength-module--requirementText--7287f";
export var requirements = "passwordStrength-module--requirements--5aa33";
export var strengthBar = "passwordStrength-module--strengthBar--3f1f1";
export var strengthBars = "passwordStrength-module--strengthBars--1fd34";
export var strengthLabel = "passwordStrength-module--strengthLabel--a3b7e";